import { Finish, Frame, Size } from 'generatedBfw/static';

export enum ArtworkFormatId {
  MEDIUM = 1001,
  LARGE = 1002,
  XLARGE = 1007,
  LUMINO = 1012,
  MAGNETS_3 = 5001,
  MAGNETS_9 = 5002,
  MAGNET_3D = 5003,
}

enum FinishType {
  MATTE = 0,
  GLOSS = 2,
}

enum FrameId {
  NONE = 0,
  FRAME_1 = 64,
  FRAME_2 = 128,
  FRAME_3 = 256,
  FRAME_4 = 512,
}

export const convertFrameNameToFrameId = (frameName: Frame): FrameId => {
  switch (frameName) {
    case Frame.NONE:
      return FrameId.NONE;
    case Frame.NATURAL:
      return FrameId.FRAME_1;
    case Frame.GRAPHITE:
      return FrameId.FRAME_2;
    case Frame.WHITE:
      return FrameId.FRAME_3;
    case Frame.BLACK:
      return FrameId.FRAME_4;
    default:
      return FrameId.NONE;
  }
};

export const convertFinishNameToFinishId = (finishName: Finish): FinishType => {
  switch (finishName.toLowerCase()) {
    case Finish.GLOSS:
      return FinishType.GLOSS;
    case Finish.MATTE:
      return FinishType.MATTE;
    default:
      return FinishType.MATTE;
  }
};

export const convertSizeToFormatId = (name: Size): ArtworkFormatId => {
  switch (name.toLowerCase()) {
    case Size.MEDIUM:
      return ArtworkFormatId.MEDIUM;
    case Size.LARGE:
      return ArtworkFormatId.LARGE;
    case Size.XLARGE:
      return ArtworkFormatId.XLARGE;
    default:
      return ArtworkFormatId.MEDIUM;
  }
};

export type ImgExtension = 'jpg' | 'webp' | 'avif';
